import Backend from "./Backend";
import {selectedCompanyStore} from "../store/SelectedCompany";
import {RecognisePurchaseInvoiceResponse} from "../model/invoice/purchase/FetchPurchaseInvoicesForReviewResponse";
import {AsyncTaskStatus} from "../model/AsyncTask";
import {ResultOrErrorDto} from "../model/ResultOrErrorDto";

class PurchaseInvoiceRecognitionApi {

    public start(fileName: string, base64FileBody: string, extraPrompt: string): Promise<string> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/invoice/purchase/recognition/submit`, {
            file: {
                name: fileName,
                file: base64FileBody,
            },
            extraPrompt
        });
    }

    public fetchStatus(taskId: string): Promise<AsyncTaskStatus> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/purchase/recognition/${taskId}/status`);
    }

    public fetchResult(taskId: string): Promise<ResultOrErrorDto<RecognisePurchaseInvoiceResponse>> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/purchase/recognition/${taskId}/result`);
    }
}

export const purchaseInvoiceRecognitionApi = new PurchaseInvoiceRecognitionApi();